import React from 'react';

type Props = {
  children: string;
  maxLength: number;
  className?: string;
};

const MiddleTrim = (props: Props) => {
  const { children, maxLength, className } = props;

  if (!children || children.length <= maxLength) {
    return <span>{children}</span>;
  }

  const midpoint = Math.ceil(children.length / 2);
  const toRemove = children.length - maxLength;
  const lStrip = Math.ceil(toRemove / 2);
  const rStrip = toRemove - lStrip;

  const beginningText = children.substring(0, midpoint - lStrip);
  const endText = children.substring(midpoint + rStrip);

  return (
    <span className={className}>
      {beginningText}...{endText}
    </span>
  );
};

export { MiddleTrim };
